export default "__VITE_ASSET__DS$CGEjY__"